import { FilterValues } from 'src/types/CataloguePage.types';

import { FacetSchema } from './TypesenseApi.types';

export enum TypesenseVehicleFields {
  ANCAP_RATING = 'ancap_rating',
  TRANSMISSION = 'transmission',
  PRICE = 'price',
  FUEL_TYPE = 'fuel_type',
  FUEL_TYPE_HIERARCHY = 'fuel_type_hierarchy',
  TOW_CAP_BRAKED = 'tow_cap_braked',
  DRIVE_TYPE = 'drive_type',
  STATE = 'state',
  YEAR = 'year',
  BODY_HIERARCHY = 'body_hierarchy',
  EMISSIONS = 'emissions',
  DOORS = 'doors',
  MODEL_HIERARCHY = 'model_hierarchy',
  HIGHLIGHTED_FEATURES = 'highlighted_features',
  COLOUR = 'colour',
  KILOMETRES = 'kilometres',
  SEATS = 'seats',
  WEEKLY_REPAYMENT = 'weekly_repayment',
  FUEL_CONSUMPTION = 'fuel_consumption',
  ENGINE_POWER = 'engine_power',
}

export const PA_DEFAULT_RATE = 0.1002;

export const TYPESENSE_VEHICLES_COLLECTION = 'products_alias';

export const KEYWORD_SEARCHABLE_FIELDS =
  'model_hierarchy,body_hierarchy,colour,fuel_type_hierarchy,highlighted_features,transmission';

/** Fuel facets: `fuel_type_hierarchy` only (no separate `fuel_type` in facet_by). */
export const FACETABLE_FIELDS =
  'ancap_rating,body_hierarchy,colour,doors,drive_type,emissions,fuel_type_hierarchy,highlighted_features,kilometres,model_hierarchy,price,seats,state,tow_cap_braked,transmission,weekly_repayment,year';

export const MAX_FACET_VALUES = 1000;

export const plpFiltersToTypesenseFields = new Map<FilterValues, TypesenseVehicleFields>([
  [FilterValues.Make, TypesenseVehicleFields.MODEL_HIERARCHY],
  [FilterValues.Model, TypesenseVehicleFields.MODEL_HIERARCHY],
  [FilterValues.CashMin, TypesenseVehicleFields.PRICE],
  [FilterValues.CashMax, TypesenseVehicleFields.PRICE],
  [FilterValues.FinanceMin, TypesenseVehicleFields.WEEKLY_REPAYMENT],
  [FilterValues.FinanceMax, TypesenseVehicleFields.WEEKLY_REPAYMENT],
  [FilterValues.YearMin, TypesenseVehicleFields.YEAR],
  [FilterValues.YearMax, TypesenseVehicleFields.YEAR],
  [FilterValues.KMMin, TypesenseVehicleFields.KILOMETRES],
  [FilterValues.KMMax, TypesenseVehicleFields.KILOMETRES],
  [FilterValues.Transmission, TypesenseVehicleFields.TRANSMISSION],
  [FilterValues.HighlightedFeatures, TypesenseVehicleFields.HIGHLIGHTED_FEATURES],
  [FilterValues.FuelCategory, TypesenseVehicleFields.FUEL_TYPE_HIERARCHY],
  [FilterValues.FuelSubType, TypesenseVehicleFields.FUEL_TYPE_HIERARCHY],
  [FilterValues.BodyType, TypesenseVehicleFields.BODY_HIERARCHY],
  [FilterValues.BodySize, TypesenseVehicleFields.BODY_HIERARCHY],
  [FilterValues.DriveType, TypesenseVehicleFields.DRIVE_TYPE],
  [FilterValues.Seats, TypesenseVehicleFields.SEATS],
  [FilterValues.Doors, TypesenseVehicleFields.DOORS],
  [FilterValues.Colour, TypesenseVehicleFields.COLOUR],
  [FilterValues.Ancap, TypesenseVehicleFields.ANCAP_RATING],
  [FilterValues.Co2emissions, TypesenseVehicleFields.EMISSIONS],
  [FilterValues.TowCapBrakedMin, TypesenseVehicleFields.TOW_CAP_BRAKED],
  [FilterValues.TowCapBrakedMax, TypesenseVehicleFields.TOW_CAP_BRAKED],
  [FilterValues.State, TypesenseVehicleFields.STATE],
  [FilterValues.FuelConsumptionMin, TypesenseVehicleFields.FUEL_CONSUMPTION],
  [FilterValues.FuelConsumptionMax, TypesenseVehicleFields.FUEL_CONSUMPTION],
  [FilterValues.EnginePowerMin, TypesenseVehicleFields.ENGINE_POWER],
  [FilterValues.EnginePowerMax, TypesenseVehicleFields.ENGINE_POWER],
]);

export const defaultFacetSchema: FacetSchema = {
  counts: [],
  field_name: 'make',
  sampled: false,
  stats: {
    avg: 0,
    max: 0,
    min: 0,
    sum: 0,
    total_values: 0,
  },
};
